var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.73398 2L5.38043 1.64645L5.73398 1.29289L6.08754 1.64645L5.73398 2ZM6.23399 11C6.23399 11.2761 6.01013 11.5 5.73399 11.5C5.45784 11.5 5.23399 11.2761 5.23399 11L6.23399 11ZM2.98043 4.04645L5.38043 1.64645L6.08754 2.35355L3.68754 4.75355L2.98043 4.04645ZM6.08754 1.64645L8.48754 4.04645L7.78043 4.75355L5.38043 2.35355L6.08754 1.64645ZM6.23398 2L6.23399 11L5.23399 11L5.23398 2L6.23398 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5348 14L10.1812 14.3536L10.5348 14.7071L10.8883 14.3536L10.5348 14ZM11.0348 5C11.0348 4.72386 10.8109 4.5 10.5348 4.5C10.2586 4.5 10.0348 4.72386 10.0348 5L11.0348 5ZM7.78121 11.9536L10.1812 14.3536L10.8883 13.6464L8.48832 11.2464L7.78121 11.9536ZM10.8883 14.3536L13.2883 11.9536L12.5812 11.2464L10.1812 13.6464L10.8883 14.3536ZM11.0348 14L11.0348 5L10.0348 5L10.0348 14L11.0348 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c13164335e90edd557264b284d64d65f.svg";
export { ForwardRef as ReactComponent };